"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tradingAccountBalanceMin = exports.katakana = exports.isDateInThePast = exports.noneNumeric = exports.alphaNumeric = exports.numberLength = exports.accountNumberFormat = exports.minMaxLimit = exports.numeric = void 0;
const stringToDate_1 = require("../stringToDate");
// Usage: Yup.addMethod(Yup.string, "numeric", numeric);
const numeric = function (message) {
    return this.test({
        message: message,
        name: 'numeric',
        exclusive: true,
        params: {
            message: message,
            exclusive: true
        },
        test: function test(value) {
            return (value + "").match(/^[0-9]+$/i);
        }
    });
};
exports.numeric = numeric;
const minMaxLimit = function (min, max, message, initialValue) {
    return this.test({
        message: message,
        name: 'minMaxLimit',
        exclusive: true,
        test: function test(value) {
            // If has initial value, means amount is pre-populated, don't validate
            if (initialValue) {
                return true;
            }
            return value >= min && value <= max;
        }
    });
};
exports.minMaxLimit = minMaxLimit;
const accountNumberFormat = function (currency, message) {
    return this.test({
        message: message,
        name: 'accountNumberFormat',
        exclusive: true,
        test: function test(value) {
            // @todo add format validation depends on psp,
            // currently applicable to perfect money wallet account format
            // validation for number of characters
            if ((value === null || value === void 0 ? void 0 : value.length) !== 9) {
                return false;
            }
            // First character should start with the selected currency
            if (currency !== '') {
                const firstLetter = currency.charAt(0).toUpperCase();
                return value ? value.startsWith(firstLetter) : false;
            }
        }
    });
};
exports.accountNumberFormat = accountNumberFormat;
const numberLength = function (min = 1, max, message) {
    return this.test({
        message: message,
        name: 'numberLength',
        exclusive: true,
        test: function test(value) {
            if ((value === null || value === void 0 ? void 0 : value.toString().length) >= min && (value === null || value === void 0 ? void 0 : value.toString().length) <= max) {
                return true;
            }
            else {
                return false;
            }
        }
    });
};
exports.numberLength = numberLength;
// Usage: Yup.addMethod(Yup.string, "alphaNumeric", alphaNumeric);
const alphaNumeric = function (message) {
    return this.test({
        message: message,
        name: 'alphaNumeric',
        exclusive: true,
        params: {
            message: message,
            exclusive: true
        },
        test: function test(value) {
            return (value + "").match(/^[a-z0-9]+$/i);
        }
    });
};
exports.alphaNumeric = alphaNumeric;
// Usage: Yup.addMethod(Yup.string, "noneNumeric", noneNumeric);
const noneNumeric = function (message) {
    return this.test({
        message: message,
        name: 'noneNumeric',
        exclusive: true,
        params: {
            message: message,
            exclusive: true
        },
        test: function test(value) {
            return !(value + "").match(/[0-9]/);
        }
    });
};
exports.noneNumeric = noneNumeric;
// Usage: Yup.addMethod(Yup.string, "isDateInThePast", isDateInThePast);
const isDateInThePast = function (message) {
    return this.test({
        message: message,
        name: 'isDateInThePast',
        exclusive: true,
        params: {
            message: message,
            exclusive: true
        },
        test: function test(value) {
            if (typeof value === 'undefined' || value === null || value === '') {
                return true; // If no value, don't validate
            }
            const currentDate = new Date();
            const currentMonth = currentDate.getMonth() + 1; // Months are zero-based in JavaScript
            const currentYear = currentDate.getFullYear();
            // Create a date object for the current date without the time part
            const nowDate = new Date(`${currentMonth}/1/${currentYear}`);
            const valueDate = (0, stringToDate_1.stringToDate)(value);
            if (!(valueDate instanceof Date)) {
                return false; // Invalid date
            }
            return valueDate.getTime() >= nowDate.getTime();
        }
    });
};
exports.isDateInThePast = isDateInThePast;
// Usage: Yup.addMethod(Yup.string, "katakana", katakana);
const katakana = function (message) {
    return this.test({
        message: message,
        name: 'katakana',
        exclusive: true,
        params: {
            message: message,
            exclusive: true
        },
        test: function test(value) {
            if (!value)
                return true; // skip empty, use required() if needed
            // Katakana full-width, spaces, ー, and full-width parentheses （）
            const katakanaRegex = /^[\u30A0-\u30FA\u30FC\u3000\s\uFF08\uFF09]+$/;
            return katakanaRegex.test(value);
        }
    });
};
exports.katakana = katakana;
// Usage: Yup.addMethod(Yup.number, "tradingAccountBalanceMin", tradingAccountBalanceMin);
const tradingAccountBalanceMin = function (message, min, tradingAccountBalance) {
    return this.test({
        message: message,
        name: 'tradingAccountBalanceMin',
        exclusive: true,
        params: {
            message: message,
            min: min,
            tradingAccountBalance: tradingAccountBalance
        },
        test: function test() {
            if (tradingAccountBalance !== undefined &&
                !isNaN(Number(tradingAccountBalance)) &&
                Number(tradingAccountBalance) < min) {
                return this.createError({
                    path: "amount",
                    message: message
                });
            }
            return true;
        }
    });
};
exports.tradingAccountBalanceMin = tradingAccountBalanceMin;
// export const isDateInThePast = function (message: string) {
//     return this.test({
//         message: message,
//         name: 'isDateInThePast',
//         exclusive: true,
//         params: {
//             message: message,
//             exclusive: true
//         },
//         test: function test(value: string) {
//             const dateValue = new Date(value);
//             const currentDate = new Date();
//             const currentYear = currentDate.getFullYear();
//             const currentMonth = currentDate.getMonth() + 1; // Months are zero-based in JavaScript
//             const currentDay = currentDate.getDate();
//             // Create a date object for the current date without the time part
//             const nowDate = new Date(`${currentMonth}/${currentDay}/${currentYear}`);
//             return dateValue.getTime() >= nowDate.getTime();
//         }
//     });
// };
